var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSadFace(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "51px",
    height: "51px",
    viewBox: "0 0 51 51",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "sad face") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "PANTALLAS-ESCAPE",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ESCENARIO-1.-PANTALLA-FEEDBACK.-Negativo-2\\xAA--Pop-up--",
    transform: "translate(-487, -233)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "sad-face",
    transform: "translate(487, 233)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.5,0 C39.60456,0 51,11.39544 51,25.5 C51,39.60456 39.60456,51 25.5,51 C11.39544,51 0,39.60456 0,25.5 C0,11.39544 11.39544,0 25.5,0 Z M25.5,3.1875 C13.22838,3.1875 3.1875,13.22838 3.1875,25.5 C3.1875,37.77162 13.22838,47.8125 25.5,47.8125 C37.77162,47.8125 47.8125,37.77162 47.8125,25.5 C47.8125,13.22838 37.77162,3.1875 25.5,3.1875 Z M15.937245,14.742315 C18.138609,14.742315 19.92162,16.525326 19.92162,18.72669 C19.92162,20.928054 18.138609,22.711065 15.937245,22.711065 C13.735881,22.711065 11.95287,20.928054 11.95287,18.72669 C11.95287,16.525326 13.735881,14.742315 15.937245,14.742315 Z M35.062245,14.742315 C37.263609,14.742315 39.04662,16.525326 39.04662,18.72669 C39.04662,20.928054 37.263609,22.711065 35.062245,22.711065 C32.860881,22.711065 31.07787,20.928054 31.07787,18.72669 C31.07787,16.525326 32.860881,14.742315 35.062245,14.742315 Z",
    id: "Combined-Shape",
    fill: "#DF2231",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.0546875,36.2578125 C34.9828125,31.9546875 30.6,29.00625 25.5,29.00625 C20.4,29.00625 16.0171875,31.9546875 13.9453125,36.2578125",
    id: "Path",
    stroke: "#DF2231",
    strokeWidth: 3.1875,
    strokeLinecap: "round"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSadFace);
export default __webpack_public_path__ + "static/media/sad-face.89b648b8d350f8d6095c4c154e451079.svg";
export { ForwardRef as ReactComponent };